import {SiteModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: SiteModel = {
  id: '',
  nombre: '',
  clienteId: '',
  companiaId: '',
  ubigeoId: '',
  departamentoId: '',
  provinciaId: '',
  direccion: '',
  referencia1: '',
  referencia2: '',
  interlocutorId: '',
  integComensalHuesped: '',
  tipoDocumentoCheckInCheckOut: '',
  requiereCenso: false,
  comensalFuncionalidadMixta: false,
  ...aditionalValues,
}
